import React from "react";
import { Divider } from "@chakra-ui/react"

const Separator = ({ orientation, ...rest }) => {
    return(
        <Divider h="0px" borderBottom=".5px solid #888" m="15px auto 37px auto!important" w="11.5rem" 
                orientation={orientation} {...rest} />
    )
}

export default Separator;